import React, { Component } from 'react'
import { Spin, Select } from 'antd'
import axios from 'axios'
import debounce from 'lodash.debounce'
import './Styles.css'

const { Option } = Select

class SelectConceptosNominaItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    }
    this.buscarConceptos = debounce(this.buscarConceptos.bind(this), 300)
  }

  componentDidMount() {
    this.buscarConceptos('')
  }

  componentDidUpdate(prevProps) {
    // Recargar cuando cambia el tipo (1, 2, 3) o la empresa
    if (prevProps.tipo !== this.props.tipo || prevProps.empresaId !== this.props.empresaId) {
      this.buscarConceptos('')
    }
    if (prevProps.value !== this.props.value && this.props.value) {
      const encontrado = this.state.opciones.find(
        (c) => c._id.toString() === this.props.value.toString()
      )
      if (!encontrado) {
        this.buscarConceptos(this.props.value || '')
      }
    }
  }

  async buscarConceptos(texto) {
    this.setState({ cargando: true })
    try {
      const res = await axios.post(
        'conceptosNomina/selectConceptosNominaItem',
        {
          empresaId: this.props.empresaId,
          tipo:      this.props.tipo,
          query:     texto,
          values:    this.props.value,
        },
        { headers: this.props.headersToken }
      )
      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.conceptosNomina || res.data.data || res.data.conceptos || [],
          primerCarga: true,
        })
      } else {
        this.setState({ opciones: [] })
      }
    } catch {
      this.setState({ opciones: [] })
    } finally {
      this.setState({ cargando: false })
    }
  }

  render() {
    const {
      noBuscar,
      mode,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      tipo,
      excludeIds,
      ...restProps
    } = this.props

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode,
      onSearch: this.buscarConceptos,
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando conceptos...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron conceptos' : null,
      loading: this.state.cargando,
    }

    if (mode === 'multiple') propsNuevas.maxTagCount = 'responsive'

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? 'white' : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    }

    return (
      <Select
        className={`custom-disabled-select ${disabled ? 'custom-disabled' : ''}`}
        dropdownMatchSelectWidth={420}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const concepto = this.state.opciones.find((c) => c._id === value)
          this.props.onChange(value, concepto)
        }}
        placeholder={
          this.state.cargando && !this.state.primerCarga ? 'Cargando...' : (placeholder || '— Seleccionar —')
        }
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones
          .filter((c) => !excludeIds || !excludeIds.has(c._id?.toString()))
          .map((c) => (
            <Option key={c._id} value={c._id}>
              {c.stringBuscar || (c.numero + ' - ' + c.descripcion)}
            </Option>
          ))}
      </Select>
    )
  }
}

export default SelectConceptosNominaItem
